module.exports = __webpack_public_path__ + "static/bytovka4-7a7a5125ad402a8da588d12223319445.jpeg";